import { Component, EventEmitter, Injector, Input, OnInit, Output } from '@angular/core';
import { AppBaseComponent } from '../../app-base.component';
import { firstValueFrom } from 'rxjs';
import { ShiftDto, ShiftService } from '@proxy/shifts';

@Component({
    selector: 'app-shift-selector',
    templateUrl: './shift-selector.component.html',
    standalone: false
})
export class ShiftSelectorComponent extends AppBaseComponent implements OnInit {
  @Input() isRequired: boolean;
  @Input() shiftIdSelected: number;
  @Input() isDisabled = false;

  @Output() changeSelectedShift = new EventEmitter<ShiftDto>();
  shifts: ShiftDto[];
  selectedShift: ShiftDto;

  constructor(
    injector: Injector,
    private readonly _shiftService: ShiftService
  ) {
    super(injector);
  }

  ngOnInit(): void {
    this.loadShifts();
    this.onSelected();
  }

  async loadShifts(): Promise<void> {
    try {
      this.showLoading();

      this.shifts = await firstValueFrom(this._shiftService.getShiftsToSelect());

      this.setSelectedShift();
    } finally {
      this.hideLoading();
    }
  }

  onSelected(): void {
    this.changeSelectedShift.emit(this.selectedShift);
  }

  setSelectedShiftById(shiftId: number): void {
    if (!shiftId) {
      return;
    }

    this.shiftIdSelected = shiftId;
    this.setSelectedShift();
  }

  private setSelectedShift(): void {
    if (this.shifts?.length && !this.isNullOrUndefined(this.shiftIdSelected)) {
      this.selectedShift = this.shifts.find(x => x.id === this.shiftIdSelected);
      this.onSelected();
    }
  }
}
